// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.connect.campaign.UpdateConnectCampaignDraftRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateConnectCampaignDraftRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Connect Campaign Id is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	connectCampaignId!: number;

	@GandalfValidator({ sizeString: { message: 'Subject cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	emailSubject!: string | null;

	@GandalfValidator({ sizeString: { message: 'Message cannot be longer than 65535 characters', minLength: 0, maxLength: 65535 } })
	@GandalfProperty({ designType: String })
	emailTemplate!: string | null;

	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfProperty({ designType: Number })
	queryId!: number | null;

	@GandalfValidator({ notNull: { message: 'Use Patient Primary Location is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	usePatientPrimaryLocation!: boolean;

}
